import { createFileRoute } from "@tanstack/react-router"
import { SubscriptionChangePage } from "@/pages/profile/subscription-change"

export const Route = createFileRoute(
	"/_authenticated/profile/subscription/change",
)({
	component: SubscriptionChangePage,
})
